/**
 * This SPA's own origin, for the callback URLs the API bakes into email links.
 *
 * Read from the browser rather than from a `VITE_WEB_URL`: the api already
 * knows where the SPA lives (`WEB_APP_URL`, which is what it uses for the
 * links it builds itself), and a second copy of the same fact in a build arg is
 * a second thing to get wrong on a preview deploy. Falls back to the empty
 * string outside a browser so importing this module is never a crash.
 */
export const WEB_ORIGIN: string = typeof window === "undefined" ? "" : window.location.origin;
